// Reducer for managing tax document data in the Redux store.
import {
  GET_TAX_DOCUMENT_LIST,
  GET_TAX_DOCUMENT_LIST_SUCCESS,
  GET_TAX_DOCUMENT_LIST_FAILURE,
  GET_TAX_DOCUMENT,
  GET_TAX_DOCUMENT_SUCCESS,
  GET_TAX_DOCUMENT_FAILURE,
} from './constant';

const initialState = {
  getTaxDocumentListData: {},
  getTaxDocumentData: null,
  token: null,
  isTaxDocumentListError: false,
  isTaxDocumentError: false,
  error: {},
  loading: true,
  hasNYDocument: false,
};

const TaxDocumentDataReducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case GET_TAX_DOCUMENT_LIST:
      return {
        ...state,
        token: payload.token,
        isTaxDocumentListError: false,
        loading: true,
      };
    case GET_TAX_DOCUMENT_LIST_SUCCESS: {
      // OneAmerica is not licensed to do business in New York state, so we check for "NY" in taxLocation.
      // In the future, once full portal is implemented, we can remove this check and handle NY from webRedirect AS flag equivalent.
      const data = payload.data;
      const taxDetails = data?.[2]?.['1099R-Details'] ?? [];
      const hasNYDocument = taxDetails.some(accountForms =>
        accountForms.some(form => form.formDetails?.taxLocation === 'NY')
      );
      return {
        ...state,
        getTaxDocumentListData: payload.data,
        // Temporarily getting the Users full name from this payload. We will eventually get this from a different API.
        customerFullName:
          payload.data && Array.isArray(payload.data) && payload.data[0]?.customerDetails?.customerFullName
            ? payload.data[0].customerDetails.customerFullName
            : '',
        hasNYDocument,
        isTaxDocumentListError: false,
        loading: false,
      };
    }
    case GET_TAX_DOCUMENT_LIST_FAILURE:
      return {
        ...state,
        error: payload.error,
        isTaxDocumentListError: true,
        loading: false,
      };
    case GET_TAX_DOCUMENT:
      return {
        ...state,
        getTaxDocumentData: null,
        loading: true,
        isTaxDocumentError: false,
      };
    case GET_TAX_DOCUMENT_SUCCESS:
      return {
        ...state,
        getTaxDocumentData: payload.data,
        loading: false,
        isTaxDocumentError: false,
      };
    case GET_TAX_DOCUMENT_FAILURE:
      return {
        ...state,
        error: payload.error,
        isTaxDocumentError: true,
        loading: false,
      };
    default:
      return state;
  }
};
export default TaxDocumentDataReducer;